const styles = {
    card: {
        border: '1px solid var(--color-border)',
        borderRadius: '8px',
        background: 'var(--color-surface)',
        padding: '12px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        width: '100%',
        alignSelf: 'stretch',
        minWidth: 0,
        maxWidth: '100%',
        boxSizing: 'border-box',
    },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        minWidth: 0,
    },
    headerLabelLayout: {
        flex: '1 1 auto',
        minWidth: 0,
        lineHeight: 'normal',
    },
};

const DemoCard = ({ header, children, headerRight }) => {
    return (
        <div style={styles.card}>
            <div style={styles.headerRow}>
                <span className="text-body-sm" style={styles.headerLabelLayout}>
                    {header}
                </span>
                {headerRight}
            </div>
            {children}
        </div>
    );
};

export default DemoCard;
